import { render, staticRenderFns } from "./RegistryWorkspace.vue?vue&type=template&id=2afe86f1"
import script from "./RegistryWorkspace.vue?vue&type=script&lang=js"
export * from "./RegistryWorkspace.vue?vue&type=script&lang=js"
import style0 from "./RegistryWorkspace.vue?vue&type=style&index=0&id=2afe86f1&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2afe86f1')) {
      api.createRecord('2afe86f1', component.options)
    } else {
      api.reload('2afe86f1', component.options)
    }
    module.hot.accept("./RegistryWorkspace.vue?vue&type=template&id=2afe86f1", function () {
      api.rerender('2afe86f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/registry/RegistryWorkspace.vue"
export default component.exports